import { ALL_GRIDS } from "../datagrids/shared/constants";
import { useSearch, useNavigate } from "@tanstack/react-router";
import { indexRoute } from "../../../routes";
import { areaOptions } from "../datagrids/shared/areaSelector";

/**
 * The area filter behind both bottom grids. The search param keeps its original
 * `algosArea` name so existing links stay valid, even though trades honour it too.
 */
export const useSelectedArea = () => {
  const { algosArea } = useSearch({ from: indexRoute.id });
  const navigate = useNavigate({ from: indexRoute.id });

  const setSelectedArea = (value: string | null) => {
    navigate({
      search: (prev) => ({
        ...prev,
        algosArea:
          value?.toLowerCase() === ALL_GRIDS.toLowerCase() ? undefined : value,
      }),
    });
  };

  return [algosArea ?? ALL_GRIDS, setSelectedArea] as const;
};

export const useSelectedAreaEicCodes = () => {
  const [selectedArea] = useSelectedArea();

  const selectedOption = areaOptions.find(
    (opt) => opt.code?.toLowerCase() === selectedArea?.toLowerCase()
  );
  const eicCodes = selectedOption?.eicCodes ?? [ALL_GRIDS];

  return [eicCodes] as const;
};
